import httpClient from '@/http-client'

export const listView = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-histories/list-views', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProductProfile = data => {
  return httpClient
    .post('/api/v1/product-histories/product-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const toExcel = data => {
  return httpClient
    .post('/api/v1/product-histories/export-to-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default { 
    listView,
    getProductProfile,
    toExcel
}
